$(function () {

    $(document).on('click', '#ppedepotitem-type_id', function (e) {
        e.preventDefault();
        var value = $(this).val();
        var sizes_select = $('#ppedepotitem-size_id');
        if (value.length > 0) {
            console.log(value);
            var url = $(this).data('sizes');
            $.when($.ajax({
                url: url + '?type_id=' + value,
                async: false,
                cache: false,
                method: 'get',
                success: function (data) {
                    if (data.status === 'success') {
                        sizes_select.empty().append('<option value="">Vyberte...</option>');
                        $.each(data.data, function (indexInArray, valueOfElement) { 
                            sizes_select.append('<option value="'+indexInArray+'">'+valueOfElement+'</option>');
                        });
                    } else {
                        bootbox.alert(data.msg);
                    }
                },
                error: function (data) {
                    bootbox.alert('Došlo k chybě při získávání seznamu velikostí.');
                }, dataType: 'json'
            })).done(function (result) {
                return result;
            });
        } else {
            sizes_select.empty().append('<option value="">Vyberte...</option>');
        }        
    });

});